export const SET_CURRENT_VALIDATOR = 'SET_CURRENT_VALIDATOR';

export function setCurrentValidator(payload) {
  return { type: SET_CURRENT_VALIDATOR, payload };
}
